const convertStringToObjectProperty = (object: any, path: string) => {
  const properties = path.split(".");
  let value = object;
  for (let i = 0; i < properties.length; i++) {
    if (properties[i]) {
      value = value.properties[i];
    }
  }
  return value;
};

export default convertStringToObjectProperty;
